import store from "../store";
import {ROLE_USER} from "../constants/app";

const isSuperAdmin = () => {
  const auth = store.getState().auth;
  return auth.user.role === ROLE_USER.SUPER_ADMIN;
};

const isMasterAdmin = () => {
  const auth = store.getState().auth;
  return auth.user.role === ROLE_USER.MASTER_ADMIN;
};

export {
  isSuperAdmin,
  isMasterAdmin,
};